import React, {useState} from "react";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {Loader} from "@pg-design/loader-module";
import {fromQueryValues, toQueryValues} from "@pg-mono/form";
import {omit} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {usePropertyList} from "../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {PropertyListType} from "../../../property_list/PropertyListTabSwitcher";
import {Country} from "../../../region/types/Country";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {ILatestQuery} from "../../../utils/latest_query";
import {OfferSidebarBox} from "../../atoms/OfferSidebarBox";
import {OfferSidebarPropertiesList} from "../../atoms/OfferSidebarPropertiesList";
import {fetchOfferDetailProperties, PropertyListTabTypes} from "../../detail/actions/fetch_offer_detail_properties";
import {propertyListTableFiltersFields} from "../../detail/components/property_list/OfferDetailPropertyListTable";
import {IOfferGroupsSimplified} from "../../detail/types/IOfferGroups";
import {OfferDisplayType} from "../../helpers/OfferDisplayType";
import {DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE} from "../../list/components/OfferListPropertiesModal";
import {ISalesOffice} from "../../types/ISalesOffice";
import {OfferPriceType} from "../../types/OfferPriceType";
import {OfferType} from "../../types/OfferType";

interface IProps {
    offer: IMapOfferSidebar;
    onOfferSidebarClose: () => void;
    requestState: RequestState;
    latestQuery: ILatestQuery;
}

export interface IMapOfferSidebar {
    address: string;
    configuration: {
        display_type: OfferDisplayType;
        hide_properties_prices_for_anonymous_users: boolean;
        is_autoresponder_enabled: boolean;
        limited_presentation?: boolean;
        phone_clip: string | null;
    };
    construction_date_range: IRangeQuery<string>;
    description: string | null;
    geo_point: {
        coordinates: [number, number];
    };
    groups: IOfferGroupsSimplified | null;
    has_required_prices: boolean | null;
    id: number;
    is_active?: boolean;
    is_holiday_location?: boolean;
    is_phone_clip_enabled: boolean;
    name: string;
    main_image: {
        m_img_224x147: string;
        m_img_760x428: string;
    };
    price_type: OfferPriceType | null;
    region: {
        country: Country;
        full_name: string;
        id: number;
        short_name_reverted: string;
        stats?: {
            region_type_voivodeship?: {name: string};
            region_type_city?: {name: string};
            region_type_town?: {name: string};
            region_type_district?: {name: string};
        };
    };
    sales_offices: ISalesOffice[];
    slug: string;
    stats: {
        distance_from_region: {
            center: boolean;
            region: string;
            distance: number;
        };
        properties_count_for_sale: number;
        properties_with_roi_count: number;
        ranges_area_min: number;
        ranges_area_max: number;
        ranges_price_m2_min: number;
        ranges_price_min: number;
        ranges_rooms_max: number;
        ranges_rooms_min: number;
    } | null;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    vendor: {
        configuration?: {
            privacy_policy_url: string | null;
            privacy_policy_file: string | null;
        };
        id: number;
        logo: {
            v_log_80x60: string;
            v_log_120x90: string;
            v_log_160x120: string;
        } | null;
        name: string;
        offices: {
            address: string;
            phone: string;
            mobile: string;
            type: number;
            region: {
                id: number;
                short_name: string;
            };
        }[];
        slug: string;
    };
}

export const MapOfferSidebar = (props: IProps) => {
    const dispatch = useDispatch();
    const latestQuery = useSelector((store: IRPStore) => store.offerListMap.list.latestQuery);
    const latestSearchFilters = fromQueryValues<ISearchFiltersFormValues>(omit(propertyListTableFiltersFields, ["price"]), latestQuery);
    const propertyList = usePropertyList(props.offer.id, PropertyListTabTypes.MODAL, undefined, DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE);
    const [currentPropertyListType, setCurrentPropertyListType] = useState<PropertyListType>(PropertyListType.TILES);

    useEffect(() => {
        if (props.offer) {
            fetchOfferDetailProperties(
                props.offer.id,
                PropertyListTabTypes.MODAL,
                DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE,
                {page: 1},
                {...toQueryValues(propertyListTableFiltersFields, latestSearchFilters)}
            )(dispatch);

            propertyList.page.setCurrentPage(1);
        }
    }, [props.offer.id]);

    //For second iteration of this project there is started file MapPropertyDetails
    return (
        <>
            <React.Suspense fallback={<Loader />}>
                <OfferSidebarBox offer={props.offer} onOfferSidebarClose={props.onOfferSidebarClose} />
                <OfferSidebarPropertiesList
                    propertyListType={currentPropertyListType}
                    onPropertyListTypeClick={setCurrentPropertyListType}
                    offer={props.offer}
                    requestState={props.requestState}
                    latestQuery={props.latestQuery}
                    propertyList={propertyList}
                />
            </React.Suspense>
        </>
    );
};
import React, {useState} from "react";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

import {Loader} from "@pg-design/loader-module";
import {fromQueryValues, toQueryValues} from "@pg-mono/form";
import {omit} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {usePropertyList} from "../../../property_list/hooks/use_property_list";
import {ISearchFiltersFormValues} from "../../../property_list/PropertyListFilters";
import {PropertyListType} from "../../../property_list/PropertyListTabSwitcher";
import {Country} from "../../../region/types/Country";
import {IRangeQuery} from "../../../request/IRangeQuery";
import {ILatestQuery} from "../../../utils/latest_query";
import {OfferSidebarBox} from "../../atoms/OfferSidebarBox";
import {OfferSidebarPropertiesList} from "../../atoms/OfferSidebarPropertiesList";
import {fetchOfferDetailProperties, PropertyListTabTypes} from "../../detail/actions/fetch_offer_detail_properties";
import {propertyListTableFiltersFields} from "../../detail/components/property_list/OfferDetailPropertyListTable";
import {IOfferGroupsSimplified} from "../../detail/types/IOfferGroups";
import {OfferDisplayType} from "../../helpers/OfferDisplayType";
import {DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE} from "../../list/components/OfferListPropertiesModal";
import {ISalesOffice} from "../../types/ISalesOffice";
import {OfferPriceType} from "../../types/OfferPriceType";
import {OfferType} from "../../types/OfferType";

interface IProps {
    offer: IMapOfferSidebar;
    onOfferSidebarClose: () => void;
    requestState: RequestState;
    latestQuery: ILatestQuery;
}

export interface IMapOfferSidebar {
    address: string;
    configuration: {
        display_type: OfferDisplayType;
        hide_properties_prices_for_anonymous_users: boolean;
        is_autoresponder_enabled: boolean;
        limited_presentation?: boolean;
        phone_clip: string | null;
    };
    construction_date_range: IRangeQuery<string>;
    description: string | null;
    geo_point: {
        coordinates: [number, number];
    };
    groups: IOfferGroupsSimplified | null;
    has_required_prices: boolean | null;
    id: number;
    is_active?: boolean;
    is_holiday_location?: boolean;
    is_phone_clip_enabled: boolean;
    name: string;
    main_image: {
        m_img_224x147: string;
        m_img_760x428: string;
    };
    price_type: OfferPriceType | null;
    region: {
        country: Country;
        full_name: string;
        id: number;
        short_name_reverted: string;
        stats?: {
            region_type_voivodeship?: {name: string};
            region_type_city?: {name: string};
            region_type_town?: {name: string};
            region_type_district?: {name: string};
        };
    };
    sales_offices: ISalesOffice[];
    slug: string;
    stats: {
        distance_from_region: {
            center: boolean;
            region: string;
            distance: number;
        };
        properties_count_for_sale: number;
        properties_with_roi_count: number;
        ranges_area_min: number;
        ranges_area_max: number;
        ranges_price_m2_min: number;
        ranges_price_min: number;
        ranges_rooms_max: number;
        ranges_rooms_min: number;
    } | null;
    street_name: string | null;
    street_number: string | null;
    type: OfferType;
    vendor: {
        configuration?: {
            privacy_policy_url: string | null;
            privacy_policy_file: string | null;
        };
        id: number;
        logo: {
            v_log_80x60: string;
            v_log_120x90: string;
            v_log_160x120: string;
        } | null;
        name: string;
        offices: {
            address: string;
            phone: string;
            mobile: string;
            type: number;
            region: {
                id: number;
                short_name: string;
            };
        }[];
        slug: string;
    };
}

export const MapOfferSidebar = (props: IProps) => {
    const dispatch = useDispatch();
    const latestQuery = useSelector((store: IRPStore) => store.offerListMap.list.latestQuery);
    const latestSearchFilters = fromQueryValues<ISearchFiltersFormValues>(omit(propertyListTableFiltersFields, ["price"]), latestQuery);
    const propertyList = usePropertyList(props.offer.id, PropertyListTabTypes.MODAL, undefined, DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE);
    const [currentPropertyListType, setCurrentPropertyListType] = useState<PropertyListType>(PropertyListType.TILES);

    useEffect(() => {
        if (props.offer) {
            fetchOfferDetailProperties(
                props.offer.id,
                PropertyListTabTypes.MODAL,
                DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE,
                {page: 1},
                {...toQueryValues(propertyListTableFiltersFields, latestSearchFilters)}
            )(dispatch);

            propertyList.page.setCurrentPage(1);
        }
    }, [props.offer.id]);

    //For second iteration of this project there is started file MapPropertyDetails
    return (
        <>
            <React.Suspense fallback={<Loader />}>
                <OfferSidebarBox offer={props.offer} onOfferSidebarClose={props.onOfferSidebarClose} />
                <OfferSidebarPropertiesList
                    propertyListType={currentPropertyListType}
                    onPropertyListTypeClick={setCurrentPropertyListType}
                    offer={props.offer}
                    requestState={props.requestState}
                    latestQuery={props.latestQuery}
                    propertyList={propertyList}
                />
            </React.Suspense>
        </>
    );
};
